import { useEffect, useRef } from "react";
import _ from "lodash";
import { evaluateValueRuleById } from "./utils";
const useFieldAutoSetValue = ({
  schemaForm,
  rules,
  pathValue,
  valueHandler,
  preview,
  normalizeValue,
  onAutoSet
}) => {
  const previousValueRef = useRef(void 0);
  const onAutoSetRef = useRef(onAutoSet);
  const normalizeValueRef = useRef(normalizeValue);
  onAutoSetRef.current = onAutoSet;
  normalizeValueRef.current = normalizeValue;
  useEffect(() => {
    if (!valueHandler) return;
    const applyAutoSetValue = () => {
      const formValues = schemaForm.getValues();
      const { matched, value } = evaluateValueRuleById(
        valueHandler,
        formValues,
        rules,
        preview
      );
      if (matched && !_.isEqual(previousValueRef.current, value)) {
        previousValueRef.current = value;
        const normalized = normalizeValueRef.current ? normalizeValueRef.current(value) : value;
        schemaForm.setValue(pathValue, normalized);
        onAutoSetRef.current?.(normalized);
      } else if (!matched && previousValueRef.current !== void 0) {
        previousValueRef.current = void 0;
      }
    };
    const subscription = schemaForm.watch(() => {
      applyAutoSetValue();
    });
    applyAutoSetValue();
    return () => subscription.unsubscribe();
  }, [schemaForm, rules, pathValue, valueHandler, preview]);
};
export {
  useFieldAutoSetValue
};
